export default __webpack_public_path__ + "static/media/restful.bd0a3a56.png";